import { Space, Tag, Tooltip } from 'antd';
import type { RoleAssignment } from './utils';
import { getRoleScopeColor, getRoleScopeLabel } from './utils';

/**
 * Render a user's role assignments as scoped tags. Lives in its own module so
 * the list page file only exports components (Vite fast-refresh constraint).
 */
export function renderRoleAssignments(
  roleAssignments: RoleAssignment[] | undefined,
  roleScopeByName: Map<string, 'internal' | 'customer' | undefined>,
): React.ReactNode {
  if (!roleAssignments || roleAssignments.length === 0) return '—';
  return (
    <Space size={[0, 4]} wrap>
      {roleAssignments.map((assignment, idx) => {
        const scope = roleScopeByName.get(assignment.role);
        const tag = (
          <Tag color={getRoleScopeColor(scope)} key={idx}>
            {assignment.role}
          </Tag>
        );
        if (Array.isArray(assignment.customerScope) && assignment.customerScope.length > 0) {
          return (
            <Tooltip
              key={idx}
              title={`${getRoleScopeLabel(scope)} role, scoped to: ${assignment.customerScope.join(', ')}`}
            >
              {tag}
            </Tooltip>
          );
        }
        return <Tooltip key={idx} title={`${getRoleScopeLabel(scope)} role`}>{tag}</Tooltip>;
      })}
    </Space>
  );
}
